import React from "react";

const AppML_Client = () => {
  return (
    <div className="tutorial-page">
      <h1>AppML Client</h1>
      <p>This is the AppML Client page content.</p>
    </div>
  );
};

export default AppML_Client;
